<template>
  <div>
    <el-dialog :title="bettingRobotsData.title" :visible.sync="bettingRobotsData.show" width="500px" center>
      <el-form inline :model="editForm">
        <el-form-item>
          <div style="margin-bottom:10px;">请输入机器人地址</div>
          <el-input style="width:450px;" clearable v-model="editForm.TgAddress" placeholder="请输入机器人地址"></el-input>
        </el-form-item>
        <el-form-item>
          <div style="margin-bottom:10px;">请输入密钥</div>
          <el-input style="width:450px;" clearable v-model="editForm.TgToken" placeholder="请输入密钥"></el-input>
        </el-form-item>
        <el-form-item>
          <div>tg无法识别指令回复内容</div>
          <el-input style="width:450px;" v-model="editForm.Intro" type="textarea" :rows="6" placeholder="tg无法识别指令回复内容"></el-input>
        </el-form-item>
        <el-form-item>
          <div>欢迎语</div>
          <el-input style="width:450px;" v-model="editForm.Welcome" type="textarea" :rows="6" placeholder="欢迎语"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="bettingRobotsData.show = false">{{$t('Cancel')}}</el-button>
        <el-button size="medium" type="primary" @click="submitEditRow">{{ $t('Confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
// import "@/assets/css/k.css";
export default {
  props: {
    bettingRobotsData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      editForm: {
        TgAddress: "",
        TgToken: "",
        Welcome: "",
        Intro: "",
      },
      editorOption: {
        placeholder: "在这里输入内容",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], //  加粗、倾斜、下划线、删除线
            ["blockquote", "code-block"], // 引用代码块
            [{ header: 1 }, { header: 2 }], // 标题，键值对应的形式，1，2 表示字体大小
            [{ list: "ordered" }, { list: "bullet" }], // 列表
            [{ script: "sub" }, { script: "super" }], // 上下标
            [{ indent: -1 }, { indent: +1 }], // 缩进
            [{ direction: "rtl" }], // 文本方向
            [{ size: ["small", false, "large", "huge"] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 几级标题
            [{ color: [] }, { background: [] }], // 字体颜色，字体背景颜色
            [{ font: [] }], // 字体
            [{ align: [] }], // 对齐方式
            ["clean"], //清除
            // ['image', 'video'], // 上传图片、上传视频
          ],
        },
      },
    };
  },
  created() {
    if (this.bettingRobotsData.rowData.TgInfo) {
      let obj = JSON.parse(this.bettingRobotsData.rowData.TgInfo);
      this.editForm.TgAddress = obj.TgAddress;
      this.editForm.TgToken = obj.TgToken;
      this.editForm.Welcome = obj.Welcome;
      this.editForm.Intro = obj.Intro;
    }
  },
  methods: {
    submitEditRow() {
      this.bettingRobotsData.rowData.TgInfo = JSON.stringify(this.editForm);
      this.$emit("submitBettingRobotsData", this.bettingRobotsData.rowData);
    },
  },
};
</script>
